module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//3.jpg?2ecd41203da9a175302dfd3ea654d188";